<script lang="ts">
  import { LogoDO } from '@shared/libs/lotties';
  import { theme, ThemeModes } from '@shared/ui/theme';

  const fullLogoIconUID = Symbol();
  const fullLogoTextUID = Symbol();
</script>

<div
  class="border-t-default-300 dark:border-t-dark-350 mt-8 flex items-center justify-center gap-3 border-t py-6 md:py-8"
>
  <p class="text-base">© Powered by</p>

  <a href="https://digitaloriginal.app" target="_blank">
    <LogoDO
      width="{94}"
      iconUID="{fullLogoIconUID}"
      textUID="{fullLogoTextUID}"
      textFill="{$theme === ThemeModes.Dark ? 'white' : 'black'}"
    />
  </a>
</div>
